/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: { price: 0 } },
  { id: 1, value: { price: 0 } },
  { id: 2, value: { price: 0 } },
  { id: 3, value: { price: 0 } },
  { id: 4, value: { price: 0 } },
  { id: 5, value: { price: 0 } },
  { id: 6, value: { price: 1 } },
  { id: 7, value: { price: 2 } },
  { id: 8, value: { price: 0 } },
  { id: 9, value: { price: 0 } },
  { id: 10, value: { price: 0 } },
  { id: 11, value: { price: 0 } },
  { id: 12, value: { price: 0 } },
  { id: 13, value: { price: 0 } },
  { id: 14, value: { price: 0 } },
];
const resourceOption = [
  {
    value: 2,
    label: 2,
  },
  {
    value: 5,
    label: 5,
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Doanh thu tính thuế thu nhập doanh nghiệp"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[11]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={0}
                  name="price"
                  readonly="true"
                  value={data[0].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Hoạt động dịch vụ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[12]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={1}
                  name="price"
                  value={data[1].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Hoạt động kinh doanh hàng hóa"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[13]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={2}
                  name="price"
                  value={data[2].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"1.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Hoạt động kinh doanh khác"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[14]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={3}
                  name="price"
                  value={data[3].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Tỷ lệ tính thuế TNDN"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[15]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={4}
                  name="price"
                  readonly="true"
                  value={data[4].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"2.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Hoạt động dịch vụ (%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[16]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <SelectTable
                  name="price"
                  id={5}
                  option={resourceOption}
                  value={data[5].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"2.2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Hoạt động kinh doanh hàng hóa (%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[17]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={6}
                  name="price"
                  readonly="true"
                  value={data[6].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"2.3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Hoạt động khác (%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[18]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={7}
                  name="price"
                  readonly="true"
                  value={data[7].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Số thuế TNDN phải nộp [19]=[12]x[16]+[13]x[17]+[14]x[18]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[19]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={8}
                  name="price"
                  readonly="true"
                  value={data[8].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Số thuế TNDN được miễn, giảm"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[20]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={9}
                  name="price"
                  value={data[9].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={10}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Số thuế TNDN phải nộp sau miễn, giảm ([21]=[19]-[20])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[21]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={10}
                  name="price"
                  readonly="true"
                  value={data[10].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={11}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Số thuế TNDN nộp thừa kỳ trước chuyển sang kỳ này (nếu có)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[22]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={11}
                  name="price"
                  value={data[11].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={12}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Số thuế TNDN đã tạm nộp trong năm đến thời điểm quyết toán"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "transparent",
                }}
              >
                {"[23]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={12}
                  name="price"
                  value={data[12].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={13}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"8"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {
                  "Chênh lệch giữa số thuế phải nộp và số thuế đã tạm nộp trong năm ([24]=[21]-[23])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[24]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={13}
                  name="price"
                  readonly="true"
                  value={data[13].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={14}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"9"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Số thuế TNDN còn phải nộp sau quyết toán ([25]=[21]-[22]-[23])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[25]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={14}
                  name="price"
                  readonly="true"
                  value={data[14].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onChange, type, option, ...rest } = props;
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const newValue = value;
    onChange({ id, value: newValue !== "" ? newValue : "", name });
  };
  return (
    <select
      id={id + 1}
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        outline: "none",
      }}
      onChange={handleSelectChange}
      {...rest}
    >
      <option value={0} disabled selected>
        0
      </option>
      {option.map((item, i) => (
        <option value={item.value} key={i}>
          {item.label}
        </option>
      ))}
    </select>
  );
}
